<template>
  <div :class="[style.accordion, $attrs.class]">
    <div :class="[style.header, ...classHeader]" @click="onHeaderClick">
      <div
        :class="[
          style.leftPart,
          showChevronLeft ? style.leftChevronStyle : null
        ]"
      >
        <slot name="title">
          <h4 :class="style.title">{{ text }}</h4>
        </slot>
        <ButtonIcon
          v-if="showChevronLeft"
          :icon="chevronRight"
          :class="[isOpen ? style.open : '']"
          @click.stop="toggleAccordion"
        />
      </div>

      <div
        :class="[
          style.rightPart,
          !isHideActions ? style.showActionsPermanently : null
        ]"
        @click.capture="onActionClick"
        @click.stop
      >
        <slot name="actions">
          <ButtonIcon
            v-if="showChevron"
            :class="[isOpen ? style.openRightChevron : '']"
            :icon="chevronUp"
            size="28"
            variant="ghost"
            @click.stop="toggleAccordion"
          />
        </slot>
      </div>
    </div>

    <transition name="accordion">
      <div v-if="isOpen" :class="[style.content, ...classContent]">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./AccordionBase.module.scss";
import GhostButton from "@/elements/UI/button/ButtonStyle/Default/ghost/GhostButton.vue";
import chevronRight from "$images/icons/button/Name=Chevron-right, Size=16, Tone=Default.svg";
import chevronUp from "$images/icons/button/Name=Chevron-up, Size=16, Tone=Default.svg";

import ButtonIcon from "@/elements/UI/button/ButtonIcon/ButtonIcon.vue";

export default defineComponent({
  name: "AccordionBase",
  components: {ButtonIcon, GhostButton},
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: ""
    },
    defaultOpen: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showChevron: {
      type: Boolean,
      default: true
    },
    openByHeaderClick: {
      type: Boolean,
      default: true
    },
    openByActionClick: {
      type: Boolean,
      default: true
    },
    showChevronWithActions: {
      type: Boolean,
      default: false
    },
    isHideActions: {
      type: Boolean,
      default: true
    },
    classHeader: {
      type: Array,
      default: () => []
    },
    classContent: {
      type: Array,
      default: () => []
    }
  },
  emits: ["open", "close", "toggle", "update:isOpen"],
  data() {
    return {
      style,
      chevronRight,
      chevronUp,
      isOpen: this.defaultOpen
    };
  },
  methods: {
    openAccordion() {
      if (this.disabled || this.isOpen) return;

      this.isOpen = true;
      this.$emit("update:isOpen", this.isOpen);
      this.$emit("toggle", this.isOpen);
      this.$emit("open");
    },

    toggleAccordion() {
      if (this.disabled) return;

      this.isOpen = !this.isOpen;
      this.$emit("update:isOpen", this.isOpen);
      this.$emit("toggle", this.isOpen);

      if (this.isOpen) {
        this.$emit("open");
      } else {
        this.$emit("close");
      }
    },

    onHeaderClick() {
      if (!this.openByHeaderClick) return;
      this.toggleAccordion();
    },
    onActionClick() {
      if (!this.openByActionClick || !this.hasActionsSlot) return;
      this.openAccordion();
    }
  },
  computed: {
    hasActionsSlot(): boolean {
      return Boolean(this.$slots.actions);
    },
    showChevronLeft(): boolean {
      return (
        this.showChevron && this.hasActionsSlot && this.showChevronWithActions
      );
    }
  }
});
</script>
